/**
 *   Created by FANGlh on 2018/11/12 15:34.
 */

import React, {Component} from 'react';
import './ClassSchedule.css';
import line_img from '../../../style/imgs/line_img.png';
import {fetchPost, fetchGet, fetchGetNoSession} from '../../../utils/fetchRequest';
import {API} from '../../../configs/api.config';
import {Toast} from 'antd-mobile';
import {List} from 'antd'
import moment from 'moment'
import {connect} from 'react-redux';
import hi0_img from '../../../style/imgs/ic_head1.png';

function HSItem(props) {
    return (
        <div className='common-flex-row' style={{height: '60px', paddingLeft: '26px'}}>
    {/*<div className='common-flex-column'*/}
    {/*style={{height: '100%', justifyContent: 'center', alignItems: 'center'}}>*/}
    {/*{props.isFirst ? <div style={{flex: 1}}></div>*/}
    {/*: <div style={{background: '#E9E9E9', flex: '1', width: '2px'}}></div>}*/}
    {/*<div className="green_point"></div>*/}
    {/*{props.isLast ? <div style={{flex: 1}}></div>*/}
    {/*: <div style={{background: '#E9E9E9', flex: '1', width: '2px'}}></div>}*/}

    {/*</div>*/}
<div className="sch_hang_sty">
        <div
    className="sch_time_sty">{props.itemdata.startTime == null ? '00:00' : props.itemdata.startTime}–{props.itemdata.endTime == null ? '00:00' : props.itemdata.endTime}</div>
    <div className="sch_class_sty">{props.itemdata.subjectName}</div>
    <img className="teach_img"
    src={props.itemdata.teacherPhoto == "" || props.itemdata.userPhoto == null ? hi0_img : props.itemdata.userPhoto}
    alt=""/>
        <div className="sch_teacher_sty">{props.itemdata.teacherName}老师</div>
    </div>
    {/*<img src={line_img} alt="" style={{width:2,height:15,marginLeft:12}}/>*/}
</div>
)
}

class ClassSchedule extends Component {

    constructor() {
        super();
        this.state = {
            curDay: new Date().getDay(),
            classData: {
                monday: [],
                tuesday: [],
                wednesday: [],
                thursday: [],
                friday: [],
                saturday: [],
                sunday: []
            },
            curDayData: [],
            Class_SchData: [1, 2, 3, 4],
        }
    }

    render() {
        const courseItems = []

        if (this.state.curDayData) {
            this.state.curDayData.forEach((itemata, index) => {
                let isFirst = false
                let isLast = false
                if (index === 0) {
                isFirst = true
                isLast = false
            }
            if (index === (this.state.curDayData.length - 1)) {
                isFirst = false
                isLast = true
            }
            courseItems.push(<HSItem key={index} itemdata={itemata}
            handelSItem={this.handelSItem}
            isFirst={isFirst} isLast={isLast}/>)

        })
        }
        return (
            <div>
            <div className="header_days_sty">
            <div onClick={this.selectDayClick.bind(this, 1)}
        className={this.state.CurDay == 1 ? "isday_click" : 'each_day_default'}>一
        </div>
        <div onClick={this.selectDayClick.bind(this, 2)}
        className={this.state.CurDay == 2 ? "isday_click" : 'each_day_default'}>二
        </div>
        <div onClick={this.selectDayClick.bind(this, 3)}
        className={this.state.CurDay == 3 ? "isday_click" : 'each_day_default'}>三
        </div>
        <div onClick={this.selectDayClick.bind(this, 4)}
        className={this.state.CurDay == 4 ? "isday_click" : 'each_day_default'}>四
        </div>
        <div onClick={this.selectDayClick.bind(this, 5)}
        className={this.state.CurDay == 5 ? "isday_click" : 'each_day_default'}>五
        </div>
        </div>
        <div className="comhline_sty" style={{marginBottom: '20px'}}></div>
        <List dataSource={this.state.curDayData} renderItem={(itemata, index) => {
            let isFirst = false
            let isLast = false
            if (index === 0) {
                isFirst = true
                isLast = false
            }
            if (index === (this.state.curDayData.length - 1)) {
                isFirst = false
                isLast = true
            }
            return <HSItem key={index} itemdata={itemata}
            handelSItem={this.handelSItem}
            isFirst={isFirst} isLast={isLast}/>
        }}/>
        {/*{courseItems}*/}
    </div>
    )
    }

    selectDayClick = (value) => {
    console.log("value", value)
    var Cdata = null
    if (value == 1) {
    Cdata = this.state.classData.curMons
} else if (value == 2) {
    Cdata = this.state.classData.curTuess
} else if (value == 3) {
    Cdata = this.state.classData.curWeds
} else if (value == 4) {
    Cdata = this.state.classData.curThurs
} else if (value == 5) {
    Cdata = this.state.classData.curFris
} else {
    Cdata = []
}
this.setState({
    CurDay: value,
    curDayData: Cdata
}, function () {
    console.log("curDayData", this.state.curDayData)
})
}

componentWillMount() {
    document.title = '课表查询'
}

componentDidMount() {
    fetchGet(API.curriculumListByStuId, {
        stuId: this.props.userInfo.user.student.stuId,
        curStatus: 1
    }, {}).then((response) => {
        if (response.success && response.data) {
        this.setState({
            classData: response.data
        }, function () {
            this.selectDayClick(this.state.curDay)
        })
    }
}).catch((error) => {
        if (typeof error === 'string') {
        Toast.fail(error, 2)
    } else {
        Toast.fail('请求异常', 2)
    }
})
}
}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo}
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ClassSchedule)